import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class S3RefService {
  private showS3RefSubject = new BehaviorSubject<boolean>(false)
  
  showS3RefConfigChange = this.showS3RefSubject.asObservable()

  toggleShowS3Ref(show?: boolean) {
    const currentValue = this.showS3RefSubject.value
    const newValue = show !== undefined ? show : !currentValue
    this.showS3RefSubject.next(newValue)
  }

  getS3RefState(): boolean {
    return this.showS3RefSubject.value
  }
}